import * as React from 'react'
import { Tooltip as DVUITooltip } from '@amzn/dvui/dist/Tooltip';
import { Text } from '@amzn/dvui/dist/Text';
import { DVString } from 'DVWebNodeUtils';
import * as styles from './Tooltip.module.scss'

interface TooltipProps {
    text: string|DVString
    children: any
    className?: string
}

export const Tooltip = (props: TooltipProps) => {
    const text = <Text
        className={styles.TooltipText}
        string={props.text} />
    return <DVUITooltip
        content={text}
        position={'top'}
        size={'s'}
        className={props.className}>
        {props.children}
    </DVUITooltip>
}